import { render, staticRenderFns } from "./BizgainComponentLayout.vue?vue&type=template&id=6fd6bff0&scoped=true&"
import script from "./BizgainComponentLayout.vue?vue&type=script&lang=js&"
export * from "./BizgainComponentLayout.vue?vue&type=script&lang=js&"
import style0 from "./BizgainComponentLayout.vue?vue&type=style&index=0&id=6fd6bff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd6bff0",
  null
  
)

export default component.exports